import { request } from '@/common/appCtx';

import { createSelectors } from './constructor/createSelectors';
import { createStore } from './constructor/createStore';

type State = {
  enums: any;
};

type Action = {
  getEnum: () => void;
};

export const useWorkforceEnums = createSelectors(
  createStore<State & Action>((set) => ({
    enums: {},
    getEnum: async () => {
      try {
        const res: any = await request.get('/api/wfm/common/enums');
        set(() => ({ enums: res.data }));
      } catch (e) {
        console.error(e);
      }
    },
  }))
);
